var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useAppSelector from "./useAppSelector";
import { useCallback } from "react";
import useEventPublisher from "./useEventPublisher";
import { viewedWidgetPage } from "../lib/Avo";
export default function usePageEvent() {
    var eventPublisher = useEventPublisher();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var open = useAppSelector(function (state) { return state.navigation.open; });
    return useCallback(function handlePageEvent(page) {
        if (!open)
            return;
        viewedWidgetPage(__assign(__assign({}, commonAnalyticsProperties), { segmentPageName_: page }));
        eventPublisher.transitionView(page);
    }, [commonAnalyticsProperties, eventPublisher, open]);
}
